export default "__VITE_ASSET__BIqaf7yC__"